
import React from "react";
import Typography from "@material-ui/core/Typography";
import * as APIStore from "../../store/APIStore";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../../store";

export type DiagnosisCodeHccProps = {
    dxCode: APIStore.PatientDiagnosis
} 

const DiagnosisCodeHcc = (props: DiagnosisCodeHccProps) => {
    let { dxCode } = props;

    return (
        <Typography variant="body2" component="p" gutterBottom>
            {`${dxCode.diagnosis.diagnosisCodeValue} - ${dxCode.shortDescription} `}
            <strong style={{ color: "red" }}>HCC CAT {dxCode.diagnosis.hccCategory}</strong>
        </Typography>
    )

};

export default DiagnosisCodeHcc